export const resizeWindow = () => {
  const resizeEvent = document.createEvent("HTMLEvents");
  resizeEvent.initEvent('resize', true, false);
  window.dispatchEvent(resizeEvent);
  setTimeout(() => {  window.dispatchEvent(resizeEvent) }, 0)
}


// WEBPACK FOOTER //
// ./src/common/resizeWindow.js